<template>
	<div>
		<base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8"></base-header>
		<div class="container-fluid mt--7">
			<div class="row">
				<div class="col-md-12 mb-5 mb-xl-0">
					<div id="swagger-ui"></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import SwaggerUI, { presets } from 'swagger-ui';
export default {
	name: 'Docs',
	data () {
		return {
			swag: false
		};
	},
	computed: {
		APIKey () {
			const { APIKey } = this.$FeathersVuex.api;
			return APIKey;
		}
	},
	mounted () {
		this.swag = SwaggerUI({
			url: "https://api.frozencrow.com/docs",
			dom_id: '#swagger-ui',
			layout: "BaseLayout",
			presets: [presets.apis],
			deepLinking: false,
			onComplete: () => {
				this.$store.dispatch('api-keys/find', {}).then(res => {
					if (res.data.length) {
						this.swag.preauthorizeApiKey("apiKey", res.data[0].apiKey);
					}
				});
			}
		});
		
	}
}
</script>
<style src="swagger-ui-themes/themes/3.x/theme-outline.css" />
